<!--
 * @Author: xiaohe
 * @LastEditors: xiaohe 选择产品
-->
<template>
  <div class="products">
    <Title title="选择产品"> </Title>
    <div class="container">
      <template v-for="(item, index) in conArray">
        <div class="box">
          <div class="left_box">
            <div class="img_logo">
              <img :src="item.logo" alt="" />
            </div>
            <div class="box_text">{{ item.name }}</div>
          </div>
          <div @click="navTo(item)" class="right_box">立即申请</div>
        </div>
      </template>
    </div>
    <a-modal
      class="rules"
      v-model="tipShow"
      title="温馨提示"
      centered
      :mask-closable="false"
    >
      <p class="tip">敬请期待！</p>
      <template v-slot:footer>
        <a-button class="btn_w btn" @click="tipShow = false" type="primary">
          关闭
        </a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import Title from "@/components/Title/index.vue";
import { entInfo } from '@/api/entCertification/entCertification.js';
export default {
  components: { Title },
  data() {
    return {
      conArray: [
        {
          logo: require("../../assets/info/icon_a.png"),
          value: "2",
          name: "履约保函",
          id: "2",
        },
        {
          value: "3",
          logo: require("../../assets/info/icon_b.png"),
          id: "3",
          name: "农民工工资保函",
        },
        {
          value: "4",
          logo: require("../../assets/info/icon_c.png"),
          id: "4",
          name: "预付款保函",
        },
        {
          value: "1",
          logo: require("../../assets/info/icon_f.png"),
          id: "1",
          name: "投标保函",
        },
      ],
      tipShow: false,
      certificationFlag: null,
      route: ["/products", "/orderCenter", "/enterprise", "/user"],
    };
  },
  mounted() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.$eventBus.$emit("handleChaneRouterInfo");
  },
  methods: {
    navTo(item) {
      if (item.value !== '1') {
        this.$router.push({ path: "/enterForm", query: { type: 'add', productV: item.value } });
      } else {
        this.tipShow = true;
      }
    },
    info() {
      entInfo().then(res => {
        if (res.data.status === 'SUCCESS') {
          this.certificationFlag = res.data.data.certificationFlag;
        }
      });
    }
  },
};
</script>

<style lang="less" scoped>
.products {
  width: 100%;
  min-height: 680px;
  .container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .box {
      margin-top: 20px;
      width: 450px;
      height: 100px;
      display: flex;
      justify-content: space-between;
      padding: 25px 20px;
      border-radius: 6px;
      background: linear-gradient( 136deg, #F0F4FD 0%, #FAFCFE 50%, #F0F4FD 100%);
    }
    .left_box {
      display: flex;
    }
    .img_logo {
      width: 60px;
      height: 60px;
      img {
        width: 60px;
        height: 60px;
      }
    }
    .box_text {
      font-size: 16px;
      font-family: Microsoft YaHei-Bold, Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      margin-left: 14px;
      padding-top: 15px;
    }
    .right_box {
      width: 100px;
      height: 32px;
      background: linear-gradient( 350deg, #3A90ED 0%, #8EC2FD 100%);
      border-radius: 2px 2px 2px 2px;
      cursor: pointer;
      text-align: center;
      line-height: 32px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #fff;
      margin-top: 10px;
    }
  }
}
.btn {
  color: #0E52D4 !important;
  border-color: #0E52D4 !important ;
  background: none !important;
}
.tip {
  font-size: 20px;
}
</style>
